import { render, staticRenderFns } from "./mod10.vue?vue&type=template&id=82ad5da4&scoped=true&"
import script from "./mod10.vue?vue&type=script&lang=js&"
export * from "./mod10.vue?vue&type=script&lang=js&"
import style0 from "./mod10.vue?vue&type=style&index=0&id=82ad5da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ad5da4",
  null
  
)

export default component.exports